import React, { useState } from "react";
import {
  EuiBadge,
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFlyout,
  EuiFlyoutBody,
  EuiFlyoutFooter,
  EuiFlyoutHeader,
  EuiHeaderAlert,
  EuiHeaderSectionItemButton,
  EuiIcon,
  EuiLink,
  EuiPortal,
  EuiTitle,
  EuiText,
  useGeneratedHtmlId,
  EuiAvatar,
} from "@elastic/eui";

const HeaderUpdates = (props) => {
  const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
  const newsFeedFlyoutId = useGeneratedHtmlId({ prefix: "newsFeedFlyout" });
  const newsFeedFlyoutTitleId = useGeneratedHtmlId({
    prefix: "newsFeedFlyoutTitle",
  });

  const alerts = [
    {
      title: (
        <>
          {" "}
          <EuiAvatar
            size="s"
            name="Astroline"
            imageUrl="https://pbs.twimg.com/profile_images/1169898928201822213/1DZg9dDp_400x400.jpg"
          />{" "}
          Backup system under maintainance{" "}
          <EuiIcon type="devToolsApp" size="m" />
        </>
      ),
      text: (
        <>
          In order to improve the service, maintenance work is being carried out
          on the backup system. We appreciate your understanding. You will be
          informed with updates as soon as possible. <br></br>
          <br></br> Astroline Routing Team.
        </>
      ),

      date: "27 Oct 2022",
      badge: <EuiBadge>1.0.3</EuiBadge>,
    },
    {
      title: (
        <>
          {" "}
          <EuiAvatar
            size="s"
            name="Astroline"
            imageUrl="https://pbs.twimg.com/profile_images/1169898928201822213/1DZg9dDp_400x400.jpg"
          />{" "}
          Welcome to our platform {props.username}!
        </>
      ),
      text: (
        <>
          It is a pleasure to welcome you to our platform, we hope you enjoy it.
          <br></br>
          <br></br> Best regards, <br></br>Astroline Routing Team.
        </>
      ),
      action: (
        <EuiLink target="_blank" external href="https://astroline.com">
          Learn more about us
        </EuiLink>
      ),
      date: "27 Oct 2022",
      badge: <EuiBadge>1.0.3</EuiBadge>,
    },
  ];

  const closeFlyout = () => {
    setIsFlyoutVisible(false);
  };

  const showFlyout = () => {
    setIsFlyoutVisible(!isFlyoutVisible);
  };

  const bellButton = (
    <EuiHeaderSectionItemButton
      aria-controls="headerFlyoutNewsFeed"
      aria-expanded={isFlyoutVisible}
      aria-haspopup="true"
      aria-label={"Alerts feed: Updates available"}
      onClick={() => showFlyout()}
      notification={true}
    >
      <EuiIcon type="bell" />
    </EuiHeaderSectionItemButton>
  );

  const flyout = (
    <EuiPortal>
      <EuiFlyout
        onClose={closeFlyout}
        size="s"
        id={newsFeedFlyoutId}
        aria-labelledby={newsFeedFlyoutTitleId}
      >
        <EuiFlyoutHeader hasBorder>
          <EuiTitle size="s">
            <h2 id={newsFeedFlyoutTitleId}>What&apos;s new</h2>
          </EuiTitle>
        </EuiFlyoutHeader>
        <EuiFlyoutBody>
          {alerts.map((alert, i) => (
            <EuiHeaderAlert
              key={`alert-${i}`}
              title={alert.title}
              action={alert.action}
              text={alert.text}
              date={alert.date}
              badge={alert.badge}
            />
          ))}
        </EuiFlyoutBody>
        <EuiFlyoutFooter>
          <EuiFlexGroup justifyContent="spaceBetween" alignItems="center">
            <EuiFlexItem grow={false}>
              <EuiButtonEmpty
                iconType="cross"
                onClick={closeFlyout}
                flush="left"
              >
                Close
              </EuiButtonEmpty>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiText color="subdued" size="s">
                <p>Version 1.0.3</p>
              </EuiText>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlyoutFooter>
      </EuiFlyout>
    </EuiPortal>
  );

  return (
    <>
      {bellButton}
      {isFlyoutVisible && flyout}
    </>
  );
};

export default HeaderUpdates;
